import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
/* Helpers */
import { getPixelData } from '../../../helpers/utils';
import { manageAssistant } from '../../../helpers/assistant';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { trackCustomPageview } from '../../../helpers/GTMEvents';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setUserDataThunk } from '../../../redux/actions/index';
/* Components */
import { Header } from '../../shared/Header';
import { Button } from '../../shared/Button';
import { Input } from '../../shared/Input';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { PageHeading } from '../../shared/PageHeading';
import { PageSubtitle } from '../../shared/PageSubtitle';
import { Footer } from '../../shared/Footer';
import { CustomModal } from '../../shared/CustomModal';
import { Spinner } from '../../shared/Spinner';
import { BizmaticaHiddenForm } from '../../shared/BizmaticaHiddenForm';
import { HiddenButton } from '../../shared/HiddenButton';

/**CSS */
import './style.css';

const checkOtpOnSubmit = (otp) => {
  if(otp.length !== 5 || otp.match("^[0-9]*$") === null) {
    return false;
  }

  return true;
}

const checkOtp = (otp, onlyRegexCheck = false) => {
  if(otp.length > 5 || otp.match("^[0-9]*$") === null) {
    return false;
  }

  return true;
}

const getSubtitle = (link) => {
  return (
    <p className="text-center">
      Non hai ricevuto l’SMS oppure desideri procedere senza?
      &nbsp;{link}
      .
    </p>
  );
}

export const OTPForm = (props) => {
    const [loaderIsVisibile, setLoaderVisibility] = useState(false);
    const [submitButtonIsEnabled, setSubmitButtonClickability] = useState(true);
    const [smsModal, setSMSModal] = useState(false);
    const [maxAttemps, setMaxAttemps] = useState(3);
    const [maxNewOTPAttemps, setMaxNewOTPAttemps] = useState(3);
    const [smsSendedModal, setSMSSendedModal] = useState(false);
    const [otp, setOTP] = useState('');
    const [responseError, setResponseError] = useState('');

    const modalRef = useRef(null), 
          innerButtonRef = useRef(null), 
          smsSendedModalRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const { search = '' } = location;

    const dispatch = useDispatch();
    const setUserData = (payload) => dispatch(setUserDataThunk(payload));
    
    const user = useSelector(state => state.user);
    const { tel: phone, cf: fiscalCode, token, tokenOTP } = user;

    const handleInputFocus = () => {
        setResponseError('');
        setSubmitButtonClickability(checkForm());
    };
    
    const handleOTP = (value) => {
        if(checkOtp(value)) {
            setOTP(value);
        }

        setResponseError('');
        setSubmitButtonClickability(checkForm());
    };

    function checkForm() {
      const valid = !window.$("#user-form").validate().errorList || window.$("#user-form").validate().errorList.length <= 0;
      if(
          valid 
          && checkOtpOnSubmit(otp)
        ) {
        return true;
      }

      return false;
    }

    const goToBizmaticaForm = () => {
      innerButtonRef?.current?.click();
    }

    const handleRetrySendOTP = function (event) {
      event.preventDefault();
      
      setLoaderVisibility(true);

      if(maxNewOTPAttemps === 0) {
        goToBizmaticaForm();
        return;
      }

      const data = {
          cf: fiscalCode,
          tel: phone,
      };
  
      const callbacks = {
        200: {
          success: function (response) {
            const {
              NeedOTP,
              TokenOTP,
              Token,
              Result,
              ResultMessage,
            } = response.data;

            setLoaderVisibility(false);

            if(Result.toLowerCase() === 'ok') {
              if(NeedOTP) {
                const data = user;
                data.token = Token;
                data.tokenOTP = TokenOTP;
                setUserData(data);
                setMaxNewOTPAttemps(maxNewOTPAttemps - 1);
                setSMSModal(false);
                setSMSSendedModal(true);
              } else {
                goToBizmaticaForm();
              }
            } else {
              setSubmitButtonClickability(true);
              setSMSModal(false);
              setResponseError('Qualcosa è andato storto. Riprova più tardi');
            }
          },
          error: function (response) {
            setLoaderVisibility(false);
            setSMSModal(false);
            setSubmitButtonClickability(true);
            setResponseError('Qualcosa è andato storto. Riprova più tardi');
          },
        },
        400: function () {
          setLoaderVisibility(false);
          setSMSModal(false);
          setSubmitButtonClickability(true);
          setResponseError('Qualcosa è andato storto. Riprova più tardi');
        },
        404: function () {
          setLoaderVisibility(false);
          setSMSModal(false);
          setSubmitButtonClickability(true);
          setResponseError('Qualcosa è andato storto. Riprova più tardi');
        },
        500: function () {
          setLoaderVisibility(false);
          setSMSModal(false);
          setSubmitButtonClickability(true);
          setResponseError('');
        },
        default: function () {
          setLoaderVisibility(false);
          setSMSModal(false);
          setSubmitButtonClickability(true);
          setResponseError('Qualcosa è andato storto. Riprova più tardi');
        },
      };
      
      handleAPIRequest(
        {
          method: 'post',
          url: getPartnerEndpoints("compass").api.checkUserData,
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        },
        callbacks,
        true
      );
    };

    const handleSubmit = function (event) {
        event.preventDefault();

        if(!checkForm()) return;

        setLoaderVisibility(true);
        setSubmitButtonClickability(false);
    
        const data = {
            //otp: otp === '12345' ? '12345678' : otp,
            otp,
            token: tokenOTP,
        };
    
        const callbacks = {
          200: {
            success: function (response) {
              const {
                NeedOTP,
                TokenOTP,
                Token,
                Result,
                ResultMessage,
              } = response.data;

              if(Result.toLowerCase() === 'ok') {
                setUserData({
                  tel: phone, 
                  cf: fiscalCode, 
                  token: Token, 
                  tokenOTP
                });
                goToBizmaticaForm();
              } else {
                setLoaderVisibility(false);
                setSubmitButtonClickability(checkForm());
                setMaxAttemps(maxAttemps - 1);
                setResponseError('OTP non verificato, riprova');
                setOTP('');
                //goToBizmaticaForm();
              }
            },
            error: function (response) {
              setLoaderVisibility(false);
              setSubmitButtonClickability(true);
              setMaxAttemps(maxAttemps - 1);
              setResponseError('OTP non verificato, riprova');
              setOTP('');
              //setResponseError('Qualcosa è andato storto. Riprova più tardi');
              //goToBizmaticaForm();
            },
          },
          400: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            //setResponseError('Qualcosa è andato storto. Riprova più tardi');
            goToBizmaticaForm();
          },
          404: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            //setResponseError('Qualcosa è andato storto. Riprova più tardi');
            goToBizmaticaForm();
          },
          500: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            //setResponseError('500 - Server error');
            goToBizmaticaForm();
          },
          default: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            //setResponseError('Qualcosa è andato storto. Riprova più tardi');
            goToBizmaticaForm();
          },
        };
    
        handleAPIRequest(
          {
            method: 'post',
            url: getPartnerEndpoints("compass").api.otpCheck,
            headers: {
              'Content-Type': 'application/json',
            },
            data: data,
          },
          callbacks,
          true
        );
    };

    /**Check if user try to access page directly */
    useEffect(() => {
      if(phone === null || phone === '') {
        history.push('/dati-utente.html');
      } else {
        getPixelData('/conferma-otp.html');
        window.$("html, body").animate({ scrollTop: 0 },"slow");
        trackCustomPageview();
        manageAssistant();
      }
    }, []);

    /**Check otp value */
    useEffect(() => {
      if(otp !== '') {
        setResponseError('');
      }
      setSubmitButtonClickability(checkForm());
    }, [otp]);

    /**Check otp max attemps value, on zero go to bizmatica */
    useEffect(() => {
      if(maxAttemps === 0) {
        goToBizmaticaForm();
      }
    }, [maxAttemps]);

    /**To manipulate overflowY on modal opening */
    useEffect(() => {
      if(loaderIsVisibile || smsModal || smsSendedModal) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'auto';
      }
    }, [loaderIsVisibile, smsModal ,smsSendedModal]);

    return(
        <div className="wrapper">
            <Spinner visible={loaderIsVisibile} />
            <Header
                logo={
                    { 
                        image: './images/logo_compass.png',
                        alt: 'Logo compass',
                        redirect: `/simulatore/simulatore-commerciale.html${search}`,
                    }
                }
                isSimulator={true}
            />
            <MainContentWrapper id="form-utente" mainClass="page-content col-xs-12 col-md-10 offset-md-1 module-deps" isSimulator={false} maxWidthHandler={false} >
                <PageHeading title="Inserisci Codice OTP" isSimulator={true}/>
                <PageSubtitle
                    image='./images/icona_otp.svg' 
                    text={
                        `<p>Inserisci nel campo sottostante il codice OTP che ti è stato inviato al numero <strong>${phone || ""}</strong>.
					    Poi clicca <strong>Procedi</strong> per confermare l’operazione.</p>`
                    }
                    alignment="left"
                />
                <form id="user-form" className="m-t-1 d-flex justify-content-center flex-column" action="#" onSubmit={(event) => handleSubmit(event)}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
                            <Input
                                className="otp-code pin-5 required"
                                type="password"
                                name="otp-sms"
                                min="0" maxlength="5" minlength="5"
                                required="required"
                                value={otp}
                                onChange={(event) => handleOTP(event.target.value)}
                                onFocus={handleInputFocus}
                                label="Codice OTP"
                            />
                        </div>
                    </div>
                    <Button 
                      isSimulator={true} 
                      color="red" 
                      text="Procedi" 
                      className="submit-button" 
                      type="submit"
                      clickEvent={(e) => handleSubmit(e)}
                      disabled={!submitButtonIsEnabled}
                      onMouseOver={checkForm}  
                      onMouseOut={checkForm}  
                    />
                  {responseError ? <p className="response-error">{responseError}</p> : null}
                  <div className="row col-xs-12 text-center no-sms-received-container">
                    {getSubtitle(<a href="#" data-toggle="modal" data-target="#modal-send-sms" onClick={() => setSMSModal(true)}>Clicca qui</a>)}
                  </div>
                </form>
                <BizmaticaHiddenForm useSubmit={true} returnUrl={`${window.location.origin}`} >
                  <HiddenButton innerRef={innerButtonRef}/>
                </BizmaticaHiddenForm>
            </MainContentWrapper>
            <Footer 
              isSimulator={true}
              showDynamicParagraph={false}
              textToUse="©Compass Banca S.p.A., socio unico direzione e coordinamento Mediobanca S.p.A., N. iscr. R.I. di Milano C.F. e P.I. 00864530159"
            />
            <CustomModal visibility={smsModal} innerRef={modalRef} closeEvent={(e) => setSMSModal(false)}>
                  <div className="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 modal-sms-container" ref={modalRef}>
                    <p className="text-center">
                      Abbiamo inviato un <b>nuovo SMS</b> al <b>numero indicato</b>.
                    </p>
                    <p className="text-center">
                        Clicca su <b>Inserisci codice OTP</b> per inserire nuovamente l’OTP<br/>oppure su <b>Procedi</b> per continuare senza
                    </p>
                    <div className="buttons-container-modal">
                        <Button 
                          isSimulator={true} 
                          color="red" 
                          text="Inserisci codice otp" 
                          type="button"
                          className="modal-button"  
                          clickEvent={(e) => handleRetrySendOTP(e)}
                        />
                        <Button 
                          isSimulator={true} 
                          color="red" 
                          text="Procedi" 
                          type="button"
                          className="modal-button"  
                          clickEvent={(e) => goToBizmaticaForm()}
                        />
                    </div>
                  </div>
            </CustomModal>
            <CustomModal visibility={smsSendedModal} innerRef={smsSendedModalRef} closeEvent={(e) => setSMSSendedModal(false)}>
                  <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 modal-sms-container" ref={smsSendedModalRef}>
                    <p className="text-center">
                      Invio avvenuto con successo al <b>numero indicato</b>: {phone ? phone + '.' : ''}
                    </p>
                    <div className="buttons-container-modal full">
                        <Button 
                          isSimulator={true} 
                          color="red" 
                          text="Chiudi" 
                          type="button"
                          className="modal-button full"  
                          clickEvent={(e) => setSMSSendedModal(false)}
                        />
                    </div>
                  </div>
            </CustomModal>
        </div>
    );
};

export default OTPForm;